import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import DeleteForever from '@material-ui/icons/DeleteForever';
import { FaEnvelope } from 'react-icons/fa';
import PermissionIconButton from '../../../Button/Permission/IconButton/PermissionIconButton';
import useStyles from './BasicActions.styles';


function BasicActionsTable({
  id,
  nome,
  onEdit,
  onRedefinirSenha,
  onDetails,
  onRemove,
  allows,
  userAllow,
  isCliente,
  isRequisicao = false,
  idRequisicaoPagtoDireto1 = 0,
  idRequisicaoPagtoDireto2 = 0,
  editDisabled = false,
  consultaDisabled = false,
  excluirDisabled = false,
  redefinirSenhaDisabled = false,
  isAbaCliente = false,
  isComercial = false,
}) {
  const styles = useStyles();
  const isAbaClienteOuComercial = isAbaCliente && isComercial;
  const isRequisicaoProtegida = id === idRequisicaoPagtoDireto1 || id === idRequisicaoPagtoDireto2;

  const consultaIsDisabled = isAbaClienteOuComercial && consultaDisabled;
  const editIsDisabled = isAbaClienteOuComercial && editDisabled;
  const excluirIsDisabled = isAbaClienteOuComercial && excluirDisabled;
  const redefinirSenhaIsDisabled = isAbaClienteOuComercial && redefinirSenhaDisabled;

  const editRequisicaoIsDisabled = isRequisicaoProtegida || editIsDisabled;
  const excluirRequisicaoIsDisabled = isRequisicaoProtegida || excluirIsDisabled;

  return (
    <div className={styles.wrapper}>
      <PermissionIconButton
        idAllow={allows.consultar}
        userAllow={userAllow}
        disabled={consultaIsDisabled}
        title="Consultar"
        onClick={() => onDetails(id)}
      >
        <ZoomInIcon />
      </PermissionIconButton>
      {!isRequisicao && (
      <PermissionIconButton
        idAllow={allows.editar}
        userAllow={userAllow}
        title="Editar"
        disabled={editIsDisabled}
        onClick={() => onEdit(id)}
      >
        <EditIcon />
      </PermissionIconButton>
      )}
      {isRequisicao && (
      <PermissionIconButton
        idAllow={allows.editar}
        userAllow={userAllow}
        disabled={editRequisicaoIsDisabled}
        title="Editar"
        onClick={() => onEdit(id)}
      >
        <EditIcon />
      </PermissionIconButton>
      )}
      {!isRequisicao && (
      <PermissionIconButton
        title="Excluir"
        idAllow={allows.excluir}
        userAllow={userAllow}
        disabled={excluirIsDisabled}
        onClick={() => onRemove(id, nome)}
      >
        <DeleteForever />
      </PermissionIconButton>
      )}
      {isRequisicao && (
      <PermissionIconButton
        title="Excluir"
        idAllow={allows.excluir}
        userAllow={userAllow}
        disabled={excluirRequisicaoIsDisabled}
        onClick={() => onRemove(id, nome)}
      >
        <DeleteForever />
      </PermissionIconButton>
      )}
      {isCliente !== undefined && (
        <PermissionIconButton
          title="Redefinir senha"
          idAllow={allows.consultar}
          userAllow={userAllow}
          disabled={redefinirSenhaIsDisabled}
          onClick={() => onRedefinirSenha(id)}
        >
          <FaEnvelope />
        </PermissionIconButton>
      )}
    </div>
  );
}

export default BasicActionsTable;
